module.exports = __webpack_public_path__ + "img/user-male-icon.6dcde8cc.svg";